module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcBAMAAACAI8KnAAAAJ1BMVEUAAAAwMDAwMDAwMDAvLy8wMDAwMDAgICAwMDAvLy8uLi4uLi4sLCyB1wvdAAAADXRSTlMA/l1TUPRXB89GPSEYNYPX8AAAAJRJREFUGNNd0bENwkAMheFfEIX6AUlBFTaADaBggEiUFGEDSjZgCCrGYAD24mQlsfTcWd/Jd37H6s1c3wfPppu6Rf/io/XU7rXjJ3UjSjeqPjiwOcElOPAKVCocqIJwLhy4BWAptXCXDjDyUAfOnAhHldpAciDJiTG2xQ/bKLsocaiD7ZG2gi9o61s4Fp0Fa7Hbp/wBds0bXXD9Nv8AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/close@2x.png
// module id = 4lJt
// module chunks = 1